import { Component, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap';

import { CBMError } from 'app/models';
import { AuthorizationService, ServiceDeskService } from 'app/services';

@Component({
  selector: 'app-dialog-report-servicedesk',
  templateUrl: './dialog-report-servicedesk.component.html',
  styleUrls: ['./dialog-report-servicedesk.component.scss']
})
export class DialogReportServicedeskComponent {
  @ViewChild('confirmDialog') confirmDialog: ModalDirective;

  public message: string;
  public isMessageSend = false;
  public errorMessages: CBMError[] = [];

  constructor(
    private readonly authorizationService: AuthorizationService,
    private readonly serviceDeskService: ServiceDeskService
  ) {}

  public show(): void {
    this.confirmDialog.show();
  }

  public hide(): void {
    this.confirmDialog.hide();
  }

  public confirm(): void {
    this.errorMessages = [];
    const user = this.authorizationService.getUser();
    const route = document.location.href;
    const messageToSend = `${this.message}
    user email: ${user.email}
    url: ${route}`;

    this.serviceDeskService.mailServicedesk(messageToSend).subscribe(
      response => (this.isMessageSend = true),
      (errors: CBMError[]) => (this.errorMessages = errors)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-report-servicedesk/dialog-report-servicedesk.component.ts